import React, { ReactElement } from 'react';
import './index.less';
const Modal = (props: any): ReactElement => {
  return (
    <div className={'xp-smart-modal ' + props.cls.modal}>
      <div className={'xp-smart-modal-mask'}></div>
      <div className={'xp-smart-modal-content'}>{props.children}</div>
    </div>
  );
};

export default Modal;
